/**
 * Common given and family names. A spoken first-and-last pair is treated as a
 * person's name in any case, which is how a live transcript arrives from Chime.
 */
const GIVEN = split(`
  aaron adam adrian aisha alan albert alejandro alexander alexis alfred alice alicia allison
  amanda amber amit amy andrea andrew angela angelica anil anita anna ann anthony antonio
  april arjun ashley asha austin barbara barry benjamin betty beverly billy bobby bonnie
  brandon brenda brian brittany bruce bryan candace carl carlos carmen carol caroline carolyn
  catherine cathy cecilia chad charles charlotte cheryl christina christine christopher cindy
  claire clara clarence cody colin connie craig crystal cynthia dale dana daniel danielle
  danny darlene darren david dawn debbie deborah deepa deepak denise dennis derek diana diane
  diego divya dolores donna doris douglas dwayne dylan earl eddie edgar edith edna eduardo
  edward eileen elaine eleanor elena elijah elizabeth ella ellen emily emma eric erica erika
  ernest esther ethan eugene eva evelyn fatima felicia fernando florence floyd frances francis
  francisco frank fred frederick gabriel gail gary geeta gene george gerald geraldine gilbert
  gina gladys glenn gloria gordon grace gregory guadalupe gwendolyn harold harry harvey
  heather helen henry herbert holly howard ida irene irma isaac isabel jack jacob jacqueline
  james jamie jane janet janice jared jasmine jason javier jean jeanette jeanne jeff jeffrey
  jennifer jenny jeremy jerry jesse jessica jesus jill jimmy joan joann joanne joe joel john
  johnny jonathan jordan jorge jose joseph joshua joy joyce juana juan judith judy julia
  julian julie june justin karen karan katherine kathleen kathryn kathy kavita kayla keith
  kelly kenneth kevin kim kimberly kristen kristin kristina kyle lakshmi larry lata laura
  lauren laurie lawrence leanne lee lena leo leon leonard leslie lillian lily linda lindsay
  lisa lois lori lorraine louis louise lucas lucia lucy luis luke lydia lynn mabel madeline
  mahesh manuel marcia margaret maria marian marianne marie marilyn mario marion marjorie
  mark marlene marsha martha martin marvin mary matthew maureen maxine meera megan mei
  melanie melissa melody michael michelle miguel mike mildred milton ming miriam mitchell
  mohammed monica morgan muhammad nancy naomi natalie nathan nathaniel neha neil nelson
  nicholas nicole nina nisha noah noor nora norma olga olive oliver olivia omar oscar
  pablo pamela patricia patrick patsy paul paula pauline pearl pedro peggy penny perry peter
  philip phillip phyllis pooja priya priscilla rachel rahul raj ralph ramon ramesh randall
  randy raul ravi raymond rebecca regina rekha renee rhonda ricardo richard rick rita robert
  roberta robin rodney roger rohit roland ron ronald rosa rose rosemary rosie roy ruby
  russell ruth ryan sabrina sally samantha samuel sandra sandy sanjay sara sarah scott sean
  seema sharon shawn sheila shelley sherry shirley sidney sofia sonia sonya stacy stella
  stephanie stephen steve steven sunil sunita suresh susan suzanne swati sylvia tammy tanya
  tara taylor teresa terrance terry thelma theresa thomas tiffany timothy tina todd tom
  tommy tony tracey tracy travis trevor troy tyler usha valerie vanessa velma vera vernon
  veronica vicki victor victoria vijay vincent viola violet virginia vivian walter wanda
  warren wayne wendy wesley willie yolanda yusuf yvonne yuki zachary
`);

const FAMILY = split(`
  adams agarwal aguilar alexander allen alvarez anderson andrews armstrong austin
  bailey baker banerjee barnes bailey bell bennett berg bergman berry bhatt bishop black
  bose boyd bradley brooks brown bryant burns butler campbell carlson carpenter carroll
  carter castillo castro chavez chen cho choi chopra choudhary clark cohen cole coleman
  collins cook cooper cox cruz cunningham dang das davis desai diaz dixon do doan duncan
  edwards elliott ellis evans ferguson fields fisher fletcher flores ford foster fox freeman
  friedman garcia gardner gibson goldberg gomez gonzales gonzalez graham gray green greene
  griffin gupta gutierrez hall hamilton han harris harrison hayes henderson hernandez
  herrera hicks hill hoang holmes hong howard hu huang hughes hunt hunter huynh iyer jackson
  jain james jang jenkins jensen jimenez johnson johnston jones jordan joshi kapoor kaplan
  katz kelley kelly kennedy khan kim king knight kumar kwon lawrence lawson le lee levy lewis
  li liang lim lin liu long lopez luo ly malhotra marshall martin mason mccoy mcdonald
  medina mehta mendoza menon meyer miller mishra mitchell moore morales morgan morris
  mukherjee munoz murphy murray myers nair naidu nelson ngo nguyen nichols nolan obrien
  olson ortiz owens palmer pandey park parker patel patterson payne perez perry peters
  peterson pham phan phillips pillai porter powell price ramirez ramos rao reddy reed
  reyes reynolds rice richardson riley rivera roberts robinson rodriguez rogers romero
  rose rosen ross rubin ruiz russell ryan salazar sanchez sanders schmidt schneider scott
  sen seo shah sharma shaw shin simmons simpson singh smith snyder spencer stein stephens
  stevens stewart stone sullivan sun taylor thompson tiwari torres tran truong turner
  vargas vasquez verma vu wagner walker wallace walsh wang ward warren watson weaver weber
  wells west white williams wilson wood woods wright wu xu yadav yang yoon young zhang
  zhao zheng zhou zhu
`);

const GIVEN_NAMES = new Set(GIVEN);
const FAMILY_NAMES = new Set(FAMILY);

export function isGivenName(word: string): boolean {
  const key = normalizeName(word);
  return key.length >= 2 && GIVEN_NAMES.has(key);
}

export function isFamilyName(word: string): boolean {
  const key = normalizeName(word);
  if (key.length >= 2 && FAMILY_NAMES.has(key)) return true;
  const parts = key.split("-").filter((part) => part.length >= 2);
  return parts.length > 1 && parts.every((part) => FAMILY_NAMES.has(part) || GIVEN_NAMES.has(part));
}

function normalizeName(word: string): string {
  return word.toLowerCase().replace(/[^a-z-]/g, "");
}

function split(words: string): string[] {
  return words.trim().split(/\s+/);
}
